import { Component, type ErrorInfo, type ReactNode } from 'react';

export class PortalErrorBoundary extends Component<
  { children: ReactNode },
  { error: Error | null }
> {
  override state = { error: null as Error | null };

  static getDerivedStateFromError(error: Error) {
    return { error };
  }

  override componentDidCatch(error: Error, info: ErrorInfo) {
    console.error('Portal rendering failed', error, info);
  }

  override render() {
    if (!this.state.error) return this.props.children;
    return (
      <main className="empty-state" role="alert">
        <h2>Unable to display this page</h2>
        <p>Please refresh the page and try again.</p>
        <button type="button" className="primary" onClick={() => window.location.reload()}>
          Refresh page
        </button>
      </main>
    );
  }
}
